import { useEffect, useState } from "react";
import { fetchProducts, type Product } from "../api/product-api";

interface Plan {
  id: string;
  category: string;
  name: string;
  price: string | number;
  rawPrice: number;
  description: string;
  features: { label: string }[];
  buttonLabel: string;
}

function mapProductToPlan(product: Product): Plan {
  const priceNum = Number(product.price);
  const formattedPrice =
    product.payment_type === "RECURRING"
      ? priceNum >= 1000000
        ? `월간 ${priceNum / 1000000}백만원`
        : priceNum >= 10000
        ? `월간 ${priceNum / 10000}만원`
        : `월간 ${priceNum}원`
      : priceNum >= 1000000
      ? `${priceNum / 1000000}백만원`
      : priceNum >= 10000
      ? `${priceNum / 10000}만원`
      : `${priceNum}원`;

  return {
    id: product.id,
    category: product.category,
    name: product.name,
    price: formattedPrice,
    rawPrice: priceNum,
    description: product.description,
    features: Array.isArray(product.feature?.label)
      ? product.feature.label.map((l: string) => ({ label: l }))
      : [],
    buttonLabel: product.category === "프랜차이즈" ? "문의하기" : "결제하기",
  };
}

export function useSubscriptionPlans(category: string) {
  const [plans, setPlans] = useState<Plan[]>([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    fetchProducts()
      .then((products) => {
        const filtered = products.filter((p) => p.category === category);
        setPlans(filtered.map(mapProductToPlan));
      })
      .catch((error) => {
        console.error("Failed to fetch products:", error);
        setPlans([]);
      })
      .finally(() => setLoading(false));
  }, [category]);

  return { plans, loading };
}
